/* eslint-env browser */
// Mounts its children only once they come within `rootMargin` of the screen,
// keeping their room until then (landing page). The tutorial videos fetched
// 5-8 MB on every visit before anyone scrolled to them: mobile data in Addis,
// and the office's storage bill. Without IntersectionObserver they mount at once.
import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';

export default function NearViewport({ children, minHeight, rootMargin = '800px 0px', sx }) {
  const ref = useRef(null);
  const [near, setNear] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (near || !el) return undefined;
    if (typeof IntersectionObserver === 'undefined') {
      setNear(true);
      return undefined;
    }
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        setNear(true);
        io.disconnect();
      }
    }, { rootMargin });
    io.observe(el);
    return () => io.disconnect();
  }, [near, rootMargin]);
  return (
    <Box ref={ref} sx={{ minHeight: near ? undefined : minHeight, ...sx }}>
      {near ? children : null}
    </Box>
  );
}
